import React from 'react';
import './App.css';
import Footer from "./Footer.js"

function Home() {
  return (
    <>
      <main className="container">
        <div className="home-content" role="banner" aria-label="Sasuvika home banner"></div>
        <article>
          <h1 className='a-h-text'>Grow Your Business with the Right Technology — Serving Businesses in Toronto &amp; the Greater Toronto Area</h1>
          <section aria-label="Company overview">
            <blockquote>
              At Sasuvika, we help businesses of all sizes succeed by building the right technology solutions for them. Whether you need a professional website, a smarter way to manage your business data, or tools to automate your daily operations — we handle all the technical work so you can focus on running your business. Based in Toronto and serving businesses across the Greater Toronto Area, we are your trusted technology partner from day one.
            </blockquote>
          </section>
          <section aria-label="Our services">
            <h2 className='a-h-text'>How We Help Your Business</h2>
            <ul className="service-list">
              <li className='a-text'>Build a professional website and online system that attracts customers and automates your business processes</li>
              <li className='a-text'>Move your business to the cloud so your team can work from anywhere, reduce IT costs, and never lose important data</li>
              <li className='a-text'>Safely transfer all your existing business data to a new modern system without any disruption to your operations</li>
              <li className='a-text'>Upgrade your outdated software into a faster, more reliable system that grows with your business</li>
              <li className='a-text'>Use smart data tools to understand your customers better, spot trends, and make smarter business decisions</li>
              <li className='a-text'>Keep your business data safe and protected from threats with the right security measures in place</li>
              <li className='a-text'>Organize and analyze all your business information in one place to get clear insights and improve performance</li>
              <li className='a-text'>We stay with you after launch — providing ongoing help, fixes, and improvements whenever your business needs them</li>
            </ul>
          </section>
        </article>
      </main>
      <Footer/>
    </>
  );
}

export default Home;
